import { RoleSwitch } from './RoleSwitch';
import { DashboardPage as AdminDashboardPage } from '../pages/admin/DashboardPage';
import { DevicesPage as AdminDevicesPage } from '../pages/admin/DevicesPage';
import { StationsPage as AdminStationsPage } from '../pages/admin/StationsPage';
import { SessionsPage as AdminSessionsPage } from '../pages/admin/SessionsPage';
import { UsersPage as AdminUsersPage } from '../pages/admin/UsersPage';
import { StationDetailPage as AdminStationDetailPage } from '../pages/admin/StationDetailPage';
import { StationEditPage as AdminStationEditPage, StationNewPage as AdminStationNewPage } from '../pages/admin/StationEditPage';
import { DashboardPage as PortalDashboardPage } from '../pages/portal/DashboardPage';
import { DevicesPage as PortalDevicesPage } from '../pages/portal/DevicesPage';
import { StationsPage as PortalStationsPage } from '../pages/portal/StationsPage';
import { SessionsPage as PortalSessionsPage } from '../pages/portal/SessionsPage';
import { UsersPage as PortalUsersPage } from '../pages/portal/UsersPage';
import { StationDetailPage as PortalStationDetailPage } from '../pages/portal/StationDetailPage';
import { StationEditPage as PortalStationEditPage, StationNewPage as PortalStationNewPage } from '../pages/portal/StationEditPage';

export function DashboardRoute() {
  return <RoleSwitch admin={AdminDashboardPage} portal={PortalDashboardPage} />;
}

export function DevicesRoute() {
  return <RoleSwitch admin={AdminDevicesPage} portal={PortalDevicesPage} />;
}

export function StationsRoute() {
  return <RoleSwitch admin={AdminStationsPage} portal={PortalStationsPage} />;
}

export function SessionsRoute() {
  return <RoleSwitch admin={AdminSessionsPage} portal={PortalSessionsPage} />;
}

export function UsersRoute() {
  return <RoleSwitch admin={AdminUsersPage} portal={PortalUsersPage} />;
}

export function PortalStationNewRoute() {
  return <RoleSwitch admin={AdminStationNewPage} portal={PortalStationNewPage} />;
}

export function PortalStationDetailRoute() {
  return <RoleSwitch admin={AdminStationDetailPage} portal={PortalStationDetailPage} />;
}

export function PortalStationEditRoute() {
  return <RoleSwitch admin={AdminStationEditPage} portal={PortalStationEditPage} />;
}
